import {
  UseMutationResult,
  UseQueryResult,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query'
import {
  CreditCardQueryResponse,
  MutateCreditCardOfferArgs,
  mutateCreditCardOffer,
  queryCreditCardOffer,
} from '../api'
import { useHostServices } from '../HostServices'
import { setCreditOfferCacheToPresented } from './utils'

export const useCreditCardOfferQuery = (): UseQueryResult<
  CreditCardQueryResponse
> => {
  const { featureFlags, session } = useHostServices()
  const isCreditCardCrossSellEnabled = featureFlags.variation(
    'FF_credit-card-cross-sell',
    false,
  )
  const { guid, access_token: accessToken } = session.data || {}

  return useQuery(
    ['credit-card-offer'],
    () => {
      return queryCreditCardOffer({
        guid,
        accessToken: accessToken as string,
      })
    },
    {
      enabled: Boolean(isCreditCardCrossSellEnabled && guid && accessToken),
      staleTime: Infinity, // if response is successful, this api is only called one time during a user's React session
    },
  )
}

export const useCreditCardOfferMutation = (): UseMutationResult<
  boolean,
  Error,
  MutateCreditCardOfferArgs
> => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: mutateCreditCardOffer,
    onSuccess: () => {
      // if we were successfully able to mutate the credit card offer, update the query cache to `presented: true` in order to avoid making additional graphQL mutations
      queryClient.setQueryData<CreditCardQueryResponse>(
        ['credit-card-offer'],
        setCreditOfferCacheToPresented,
      )
    },
  })
}
